// Libs
import classNames from 'classnames/bind';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseSelect } from '~/components/common';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IBaseOption } from '~/utils/interface/common';
import { IFormEstimate } from '~/utils/interface/estimate';
import { mockDataEstimateFieldsType, mockDataUnitEstimate } from '~/utils/mockData/estimate';
// Styles, images, icons
import styles from './EstimateFields.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const EstimateFields = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/estimate']);

  const {
    control,
    formState: { errors },
  } = useFormContext<IFormEstimate>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2
      component={'div'}
      id='estimateFieldsComponent'
      className={cx('container')}
      container
      rowSpacing={'12px'}
      columnSpacing={'12px'}
    >
      <Grid2 size={6}>
        <Controller
          name='type'
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseSelect
              label={t('form_estimate_fields_label_type')}
              value={value || EMPTY_STRING}
              onChange={({ value: optionValue }: IBaseOption) => onChange(optionValue)}
              options={mockDataEstimateFieldsType}
              errorMessage={errors.type?.message}
            />
          )}
        />
      </Grid2>

      <Grid2 size={6}>
        <Controller
          name='unit'
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseSelect
              label={t('form_estimate_fields_label_unit')}
              value={value || EMPTY_STRING}
              onChange={({ value: optionValue }: IBaseOption) => onChange(optionValue)}
              options={mockDataUnitEstimate}
              errorMessage={errors?.unit?.message}
            />
          )}
        />
      </Grid2>
    </Grid2>
  );
};

export default EstimateFields;
